/* global window document */
import URLQueryBuilder from 'url-query-builder';

import './OverviewFilter.scss';
import template from './OverviewFilter.vhtml';

export default {
	name: 'OverviewFilter',
	template: template,
	props: {
		'categories': {
			type: Object,
			required: true
		},
		'categoryName': {
			type: String,
			default: '',
		},
		'categoryNamePlural': {
			type: String,
			default: '',
		},
		'selectedCategory': {
			type: String,
			default: '',
		},
		'searchLabel': {
			type: String,
			default: '',
		},
		'search': {
			type: String,
			default: ''
		}
	},
	data: () => ({
		internalSearch: '',
		internalCategory: ''
	}),
	computed: {
		formatedSearchLabel: vm => vm.searchLabel !== '' ? vm.searchLabel : vm.$t('search'),
		formatedCategoryLabel: vm => vm.categoryName !== '' ? vm.categoryName : vm.$tc('category', 1),
		formatedCategoryPlaceholder: vm => vm.categoryNamePlural !== '' ? vm.categoryNamePlural : vm.$tc('category', 2),
	},
	watch: {
		internalSearch(val) {
			this.$emit('change-search', val);
			this.updateUrl();
		},
		internalCategory(val) {
			this.$emit('change-category', val);
			this.updateUrl();
		},
		selectedCategory(val) {
			this.internalCategory = val;
		},
		search(val) {
			this.internalSearch = val;
		},
	},
	methods: {
		setupPlaceholder(str) {
			return `${str}...`;
		},
		updateUrl() {
			// const q = new URLQueryBuilder(document.location.href, {
			// 	search: this.internalSearch,
			// 	category: this.internalCategory,
			// });
			// window.history.replaceState(null, null, q.get());

			window.history.replaceState(null, null, `${location.pathname}?search=${this.internalSearch}`)
			if (this.internalSearch.length === 0){
				window.history.replaceState(null, null, `${location.pathname}`)
			}

		},
	},
	created() {
		this.internalSearch = this.search;
		this.internalCategory = this.selectedCategory;
	}
};
